/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetMyRunQueryResponse, TransfersControllerGetMyRunQueryParams, TransfersControllerGetMyRun400, TransfersControllerGetMyRun401, TransfersControllerGetMyRun403, TransfersControllerGetMyRun404 } from "../../models/transfersController/TransfersControllerGetMyRun";

function getTransfersControllerGetMyRunUrl() {
  const res = { method: 'GET', url: `/api/v1/transfers/my-runs` as const }  
  return res
}

/**
 * @summary Get my organization transfer run status
 * {@link /api/v1/transfers/my-runs}
 */
export async function transfersControllerGetMyRun(params: TransfersControllerGetMyRunQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransfersControllerGetMyRunQueryResponse, ResponseErrorConfig<TransfersControllerGetMyRun400 | TransfersControllerGetMyRun401 | TransfersControllerGetMyRun403 | TransfersControllerGetMyRun404>, unknown>({ method : "GET", url : getTransfersControllerGetMyRunUrl().url.toString(), params, ... requestConfig })  
  return res.data
}